export enum DriverEventType {
  ACTION,
  NOTIFY,
}

export interface DriverNotifier {
  error(message: string): void;
}

export interface DriverActionEffect<TAction> {
  type: DriverEventType.ACTION;
  action: TAction;
}

export interface DriverNotificationEffect {
  type: DriverEventType.NOTIFY;
  message: string;
}

export type DriverEffect<TAction> =
  | DriverActionEffect<TAction>
  | DriverNotificationEffect;

/**
 * Processes a pre-drained snapshot of effects into Redux actions and immediate notifications.
 * Notifications are fired inline; actions are returned to the caller for dispatch.
 */
export function flushDriverEffects<TAction>(
  effects: ReadonlyArray<DriverEffect<TAction>>,
  notifier: DriverNotifier,
): TAction[] | undefined {
  if (effects.length === 0) {
    return undefined;
  }

  const actions: TAction[] = [];

  for (const effect of effects) {
    if (effect.type === DriverEventType.NOTIFY) {
      notifier.error(effect.message);
    } else if (effect.type === DriverEventType.ACTION) {
      actions.push(effect.action);
    }
  }

  return actions.length > 0 ? actions : undefined;
}
